// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import jwtDecode from 'jwt-decode'

import App from './App'
import store from './store'
import router from './router'
import Raven from 'raven-js'

import Buefy from 'buefy'
import ElementUI from 'element-ui'
import lang from 'element-ui/lib/locale/lang/ru-RU'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import RavenVue from 'raven-js/plugins/vue'
import VeeValidate from 'vee-validate'

import * as VueGoogleMaps from 'vue2-google-maps'

import 'buefy/lib/buefy.css'
import 'swiper/dist/css/swiper.css'

import { apiUrl } from './config'
import { clearToken, getToken, isTokenExpired } from './helpers/auth-storage'
import { refreshAccessToken } from './helpers/auth-client'

import moment from 'moment'

moment.locale('ru')

const apiAxios = axios.create({
  baseURL: `${apiUrl}/admin/`,
  withCredentials: true
})

apiAxios.interceptors.request.use((config) => {
  const activeToken = getToken()
  if (activeToken) {
    config.headers = config.headers || {}
    if (!config.headers.Authorization) {
      config.headers.Authorization = `JWT ${activeToken}`
    }
  }
  return config
})

function isAuthRequest(config) {
  if (!config || !config.url) {
    return false
  }

  const method = (config.method || 'get').toLowerCase()
  const url = String(config.url)
  if (url.indexOf('account/refresh') !== -1 || url.indexOf('account/logout') !== -1) {
    return true
  }
  return method === 'post' && /(^|\/)account\/?$/.test(url)
}

apiAxios.interceptors.response.use(response => response, error => {
  const requestConfig = error && error.config
  const responseStatus = error && error.response && error.response.status

  if (!requestConfig || responseStatus !== 401 || requestConfig.__isRetryRequest || isAuthRequest(requestConfig)) {
    return Promise.reject(error)
  }

  return refreshAccessToken()
    .then((newAccessToken) => {
      requestConfig.__isRetryRequest = true
      requestConfig.headers = requestConfig.headers || {}
      requestConfig.headers.Authorization = `JWT ${newAccessToken}`
      return apiAxios(requestConfig)
    })
    .catch((refreshError) => (
      store
        .dispatch('logout')
        .catch(() => undefined)
        .then(() => Promise.reject(refreshError))
    ))
})

Vue.use(Buefy)
Vue.use(ElementUI, { locale: lang })
Vue.use(VueAxios, apiAxios)
Vue.use(VueAwesomeSwiper)
Vue.use(VeeValidate)

Vue.config.productionTip = true

Vue.filter('truncate', function (value, length) {
  return value.length > length ? value.slice(0, length - 1) + '…' : value
})

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyC36JGZn_Nl3Go2QyT9PQdnT8uACjbrSdE',
    libraries: 'places'
  }
})

Vue.filter('formatDate', function (value) {
  return moment(value).format('LL')
})

Vue.filter('stripHTML', function (str) {
  if (str && typeof str === 'string') {
    let element = document.createElement('div')
    str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '')
    str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '')
    element.innerHTML = str
    str = element.textContent
    element.textContent = ''
  }
  return str
})

const currentLocation = window.location.origin
if (currentLocation.search('grottbjorn') !== -1) {
  let env = currentLocation.search('grottbjorn.sync.su') !== -1 ? 'prod' : 'stage'
  Raven
    .config(
      'https://8ba833957c484dc783e63fbbc788694e@logs.corp.jetstyle.in/15',
      { environment: env }
    )
    .addPlugin(RavenVue, Vue)
    .install()
}

async function bootstrapAuth() {
  let accessToken = getToken()

  if (!accessToken || isTokenExpired(accessToken)) {
    try {
      accessToken = await refreshAccessToken()
    } catch (e) {
      clearToken()
      accessToken = null
    }
  }

  if (accessToken) {
    try {
      const decoded = jwtDecode(accessToken)
      if (!decoded || !decoded.user) {
        throw new Error('auth error')
      }
      apiAxios.defaults.headers.common['Authorization'] = `JWT ${accessToken}`
      store.commit('SET_USER', decoded.user)
      return
    } catch (e) {
      clearToken()
    }
  }

  delete apiAxios.defaults.headers.common['Authorization']
  store.commit('SET_USER', null)
  if (router.currentRoute.name !== 'Login') {
    router.push({ name: 'Login' })
  }
}

function mountApp() {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    store,
    router,
    template: '<App/>',
    components: { App }
  })
}

/* eslint-disable no-new */
bootstrapAuth().finally(mountApp)



// WEBPACK FOOTER //
// ./src/main.js